module.exports = __webpack_public_path__ + "img/77.4f497c92.jpg";